import { Injectable } from '@angular/core';
import { IChannelCommunicatorInterface } from '../../../../interfaces/channel-communicator.interface';
import { ExternalResponse } from '../../../../models/channel-communicator/external-response.model';
import { ExternalRequest } from '../../../../models/channel-communicator/external-request.model';
import { CHANNEL } from '../../../../constants/channel.constants';
import { BaseChannelCommunicatorService } from '../base-channel-communicator.service';
import { LoadingService } from '../../../loading/loading.service';

@Injectable()

/**
 * Configuración inicial para la comunicación con superapp
 *
 * *Initial config for comunication with superapp*
 *
 * @type {class}
 * @extends {BaseChannelCommunicatorService}
 * @implements {IChannelCommunicatorInterface}
 */
export class SuperappImplService extends BaseChannelCommunicatorService implements IChannelCommunicatorInterface {
  CHANNEL_ID = CHANNEL.SUPERAPP.CODE;
  CHANNEL: any;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @function initService
   */
  constructor(
    private loading: LoadingService,

  ) {
    super();

    this.initService();
  }

  /**
   * Creación de la promesa para la comunicación con portalpn
   *
   * *Promise creation for portalpn communication*
   *
   * @param {string} op
   */
  createPromise(op: string): Promise<ExternalResponse> {
    return new Promise((resolve, _reject) => {
      let data: ExternalResponse;

      const callback = (event: any) => {
        try {
          data = JSON.parse(event.data);
        } catch (error) {
          return;
        }
        if (data.origin !== CHANNEL.SUPERAPP.NAME || data.op !== op) { return; }
        resolve(data);

        window.removeEventListener('message', callback);
        document.removeEventListener('message', callback);
      };

      window.addEventListener('message', callback);
      document.addEventListener('message', callback);
    });
  }

  /**
   * Llamada a una función Nativa dependiendo del canal
   *
   * *Calls native function depending on the channel*
   *
   * @param {ExternalRequest} request
   */
  postMessageToChannel(request: ExternalRequest) {
    const getExternalContext = (): any => {
      return new Promise(async (resolve, reject) => {

        const maxTime = 5000;
        const gradient = 100;

        for (let i = gradient; i < maxTime; i += gradient) {
          if (window['ReactNativeWebView']) {
            resolve(window['ReactNativeWebView']);

            return;

          }

          await new Promise(innerResolve => {
            setTimeout(innerResolve, gradient);
          });

        }

        reject('Fatal. External context not found.');
      });
    };

    window.parent.postMessage(JSON.stringify(request), '*');

    getExternalContext().then(context => {
      context.postMessage(JSON.stringify(request));
    }, err => {
      console.error(err + ' Application unavailable.');
    });
  }
}
